import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "data-table-column-reorder__popover"
}
const _hoisted_2 = ["draggable", "onDragstart", "onDragover"]
const _hoisted_3 = { class: "data-table-column-reorder__label" }

import { ref, onMounted, onUnmounted } from "vue";
import { Icon } from "@iconify/vue";
import Button from "@/components/ui/Button.vue";
import Toggle from "@/components/ui/Toggle.vue";
import type { ColumnState } from "./types";

interface Props {
  columns: ColumnState[];
  stickyColumns?: number;
  onReorder?: (columns: ColumnState[]) => void;
  onVisibilityChange?: (key: string, visible: boolean) => void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ColumnReorder',
  props: {
    columns: {},
    stickyColumns: { default: 1 },
    onReorder: {},
    onVisibilityChange: {}
  },
  setup(__props: any) {

const props = __props;

const reorderOpen = ref(false);
const draggedIndex = ref<number | null>(null);
const reorderWrapperRef = ref<HTMLElement | null>(null);

const toggleReorder = () => {
  reorderOpen.value = !reorderOpen.value;
};

const handleDragStart = (e: DragEvent, index: number) => {
  if (index < props.stickyColumns) {
    e.preventDefault();
    return;
  }
  draggedIndex.value = index;
  if (e.dataTransfer) {
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/plain", "");
  }
};

const handleDragOver = (e: DragEvent, index: number) => {
  e.preventDefault();
  if (draggedIndex.value === null || draggedIndex.value === index) return;
  if (index < props.stickyColumns) return;

  const newColumns = [...props.columns];
  const draggedColumn = newColumns[draggedIndex.value];
  newColumns.splice(draggedIndex.value, 1);
  newColumns.splice(index, 0, draggedColumn);

  draggedIndex.value = index;
  props.onReorder?.(newColumns);
};

const handleDragEnd = () => {
  draggedIndex.value = null;
};

const handleVisibilityChange = (key: string, visible: boolean) => {
  props.onVisibilityChange?.(key, visible);
};

const handleClickOutside = (event: MouseEvent) => {
  if (reorderWrapperRef.value && !reorderWrapperRef.value.contains(event.target as Node)) {
    reorderOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "data-table-column-reorder",
    ref_key: "reorderWrapperRef",
    ref: reorderWrapperRef
  }, [
    _createVNode(Button, {
      variant: "secondary",
      size: "sm",
      onClick: toggleReorder
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Icon), { icon: "mdi:view-column" }),
        _cache[2] || (_cache[2] = _createTextVNode(" Columns ", -1))
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "reorder-popover" }, {
      default: _withCtx(() => [
        (reorderOpen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "data-table-column-reorder__header" }, "Drag to reorder • Toggle visibility", -1)),
              _createElementVNode("div", {
                class: "data-table-column-reorder__list",
                onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (column, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: column.key,
                    class: _normalizeClass([
              'data-table-column-reorder__item',
              {
                'data-table-column-reorder__item--dragging': draggedIndex.value === index,
                'data-table-column-reorder__item--locked': index < __props.stickyColumns,
              },
            ]),
                    draggable: index >= __props.stickyColumns,
                    onDragstart: (e) => handleDragStart(e, index),
                    onDragover: _withModifiers((e) => handleDragOver(e, index), ["prevent"]),
                    onDragend: handleDragEnd
                  }, [
                    _createVNode(_unref(Icon), {
                      icon: index < __props.stickyColumns ? 'mdi:lock-outline' : 'mdi:drag-vertical',
                      class: "data-table-column-reorder__drag-handle"
                    }, null, 8, ["icon"]),
                    _createElementVNode("span", _hoisted_3, _toDisplayString(column.header), 1),
                    (index >= __props.stickyColumns)
                      ? (_openBlock(), _createBlock(Toggle, {
                          key: 0,
                          "model-value": column.visible,
                          "onUpdate:modelValue": (val) => handleVisibilityChange(column.key, val),
                          size: "sm",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                        }, null, 8, ["model-value", "onUpdate:modelValue"]))
                      : _createCommentVNode("", true)
                  ], 42, _hoisted_2))
                }), 128))
              ], 32)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512))
}
}

})